import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { toast } from 'react-toastify';
import DirectionsControl from './Directions';
import LocationsControl from './Locations';
import { Segment, Tab, Button, Icon, Visibility } from 'semantic-ui-react';
import { translations } from './translations';
import {
  updateTab,
  updateProfile,
  updatePermalink,
  zoomTo,
  resetSettings,
  toggleDirections,
  updateLang,
  updateGeoJsonId,
  updateSrcCoord,
} from 'actions/commonActions';
import { fetchReverseGeocodePerma, clearWaypoints, clearRoutes, makeRequest } from 'actions/directionsActions';
import {
  fetchReverseGeocodeIso,
  updateIsoSettings,
} from 'actions/isochronesActions';
import { VALHALLA_OSM_URL } from 'utils/valhalla';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import myLocationIcon from 'images/marker-5.png';

import myLocationButtonIcon from 'images/marker-5.png';
import umCampusButtonIcon from 'images/um-logo.png';
import englishButtonIcon from 'images/EN-en.png';
import chineseButtonIcon from 'images/CH-ch.png';
import portugueseButtonIcon from 'images/PT-pt.png';
import { 
  polygon_UmEmap,
  coord_defaultLocateMe,
  map_minZoomLevel,
  map_maxZoomLevel,
  map_defaultZoomLevel,
  coord_UmEmapCenter,
} from 'utils/mapCoords';
import { 
  mapClearAllLayerContents,
  mapClearLocationLayerGroup,
  getCurrentUserCoordinates,
  isInsidePolygon,
} from 'utils/mapUtils';

const pairwise = (arr, func) => {
  let cnt = 0;
  for (let i = 0; i < arr.length - 1; i += 2) {
    func(arr[i], arr[i + 1], cnt);
    cnt += 1;
  }
};

class MainControl extends React.Component {

  state = {
    hasChangeActiveTabOnce: false
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.object,
    activeDataset: PropTypes.string,
    activeTab: PropTypes.number,
    activeLang: PropTypes.string.isRequired,
    geoJsonId: PropTypes.string,
    srcCoord: PropTypes.string,
    showDirectionsPanel: PropTypes.bool,
    lastUpdate: PropTypes.object,
    map: PropTypes.object,
    initialize: PropTypes.func.isRequired,
    setActiveLanguage: PropTypes.func.isRequired,
    activeLanguage: PropTypes.object,
    setActiveLang: PropTypes.func.isRequired,
  };

  async getLastUpdate() {
    const response = await fetch(`${VALHALLA_OSM_URL}/status`);
    const data = await response.json();
    this.setState({
      lastUpdate: new Date(data.tileset_last_modified * 1000),
    });
  }

  componentDidMount = () => {

    const { dispatch, initialize, activeLang, setActiveLang, geoJsonId, srcCoord } = this.props;   

    initialize({
      languages: [
        { name: 'English', code: 'en' },
        { name: '中文', code: 'zh' },
        { name: 'Português', code: 'pt' },
      ],
      translation: translations,
      options: { renderToStaticMarkup: false },
    });
  
    this.getLastUpdate();
  
    const params = Object.fromEntries(new URL(document.location).searchParams);
  
    if ('profile' in params) {
      dispatch(updateProfile({ profile: params.profile }));
    }
  
    if ('lang' in params && params.lang !== activeLang) {      
      setActiveLang(params.lang);
      dispatch(updateLang(params.lang));
    }

    if ('geoJsonId' in params && params.geoJsonId !== geoJsonId) {      
      setActiveLang(params.geoJsonId);
      dispatch(updateGeoJsonId(params.geoJsonId));
    }

    if ('srcCoord' in params && params.srcCoord !== srcCoord) {      
      setActiveLang(params.srcCoord);
      dispatch(updateSrcCoord(params.srcCoord));
    }    
   
    let activeTab;
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/directions'
    ) {
      activeTab = 0;
      dispatch(updateTab({ activeTab }));
    } else if (window.location.pathname === '/isochrones') {
      activeTab = 1;
      dispatch(updateTab({ activeTab }));
    }
  
    if ('wps' in params && params.wps.length > 0) {
      const coordinates = params.wps.split(',').map(Number);
      const processedCoords = [];
      pairwise(coordinates, (current, next, i) => {
        const latLng = { lat: next, lng: current };
        const payload = {
          latLng,
          fromPerma: true,
          permaLast: i === coordinates.length / 2 - 1,
          index: i,
        };
        processedCoords.push([latLng.lat, latLng.lng]);
        if (activeTab === 0) {
          dispatch(fetchReverseGeocodePerma(payload));
        } else {
          dispatch(fetchReverseGeocodeIso(current, next));
  
          if ('range' in params && 'interval' in params) {
            const maxRangeName = 'maxRange';
            const intervalName = 'interval';
            const maxRangeValue = params.range;
            const intervalValue = params.interval;
  
            dispatch(
              updateIsoSettings({
                maxRangeName,
                intervalName,
                value: maxRangeValue,
              })
            );
            dispatch(
              updateIsoSettings({
                undefined,
                intervalName,
                value: intervalValue,
              })
            );
          }
  
          if ('denoise' in params) {
            dispatch(
              updateIsoSettings({
                denoiseName: 'denoise',
                value: params.denoise,
              })
            );
          }
          if ('generalize' in params) {
            dispatch(
              updateIsoSettings({
                generalizeName: 'generalize',
                value: params.generalize,
              })
            );
          }
        }
      });
      dispatch(zoomTo(processedCoords));
      dispatch(resetSettings());      
    }   
  };

  componentDidUpdate = (prevProps) => {
    
    const { dispatch, message, activeLang, setActiveLanguage, geoJsonId, srcCoord } = this.props;
    const params = Object.fromEntries(new URL(document.location).searchParams);    

    if (message.receivedAt > prevProps.message.receivedAt) {
      toast(message.type);
    }
  
    if (prevProps.map !== this.props.map) {
      // add code if necessary
    }
  
    if (prevProps.activeLang !== activeLang) {      
      //setActiveLanguage(activeLang); // Update Drawer's Language
    }
    //setActiveLanguage(activeLang);
    //console.log("In Main Control, geoJsonId:", geoJsonId);
    //console.log("In Main Control, srcCoord:", srcCoord);


    //setActiveLang('activeLang');
    //dispatch(updateLang('activeLang'));


    if (geoJsonId && srcCoord && !this.state.hasRunOnce) {
      let activeTab = 1;
      dispatch(updateTab({ activeTab }));

      // Make sure to run this only once
      this.setState({ hasRunOnce: true });
    }
  };

  handleTabChange = (event, data) => {

    const { dispatch } = this.props;
    const activeTab = data.activeIndex;

    dispatch(updateTab({ activeTab }));
    dispatch(updatePermalink());

    const { map } = this.props;
    if (map) {
      //mapClearAllLayerContents(map);      
    }      

    if (data.activeIndex === 0) { // Changing to Locations Tab
      if (map) {
        //mapClearAllLayerContents(map);      
      }   
      //dispatch(clearWaypoints());
      //dispatch(clearRoutes());        
    }   

    if (data.activeIndex === 1) { // Changing to Search Tab
      if (map) {
        mapClearLocationLayerGroup(map);      
      }                
    }

  };

  handleDirectionsToggle = (event, data) => {
    
    const { dispatch } = this.props;
    const { showDirectionsPanel } = this.props;
    if (!showDirectionsPanel) {
      document
        .getElementsByClassName('heightgraph-container')[0]
        .setAttribute('width', window.innerWidth * 0.75);
    } else {
      document
        .getElementsByClassName('heightgraph-container')[0]
        .setAttribute('width', window.innerWidth * 0.9);
    }
    dispatch(toggleDirections());
  };

  handleLanguageChange = (value) => {
    const { setActiveLanguage, dispatch, setActiveLang } = this.props;

    // Clear all waypoints and routes
    //dispatch(clearWaypoints());
    //dispatch(clearRoutes());    
    
    const { map } = this.props;
    if (map) {
      mapClearLocationLayerGroup(map);      
    }  
  
    // update language
    setActiveLanguage(value);
    dispatch(updateLang(value));
    setActiveLang(value);
  };

  handleLocateMe = () => {

    const { dispatch } = this.props;
    
    getCurrentUserCoordinates((error, coordinates) => {      

      if (error) {
        console.error("Error Code = " + error.code + " - " + error.message);
        //alert(error.message);        
        if (this.props.activeLang == "zh") {
          alert("您的地理定位功能已停用。");
        } else {
          alert("Your geolocation feature has been disabled.");
        }
        return;
      }

      let tempCoord;
      if (isInsidePolygon(coordinates, polygon_UmEmap)) {
        tempCoord = coordinates;
        // do something if necessary
      } else {
        if (this.props.activeLang == "zh") {
          alert("由於你當前位置並不在澳門大學校園，所以將當前位設定為默認地點。");
        } else {
          alert("Since your current location is Out of UM Campus, the current location will be set as the default location.");
        }
        
        coordinates = coord_defaultLocateMe;
      }

      const [latitude, longitude] = coordinates;
      const { map } = this.props;

      if (map) {
        /*
        map.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.removeLayer(layer);
          }
        });*/
        //dispatch(clearRoutes());
        mapClearLocationLayerGroup(map);
        //dispatch(clearWaypoints);
        //dispatch(clearRoutes());

        const layerGroup = L.layerGroup().addTo(map);
        layerGroup.type = 'location'; 

        const marker = L.marker([latitude, longitude], {
          icon: L.icon({
            iconUrl: myLocationIcon,
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -32],
          }),
        }).addTo(layerGroup);

        map.flyTo([latitude, longitude], map_maxZoomLevel);
        if (this.props.activeLang === 'zh') {
          marker.bindPopup("<div style='text-align: center;'>你的位置</div>").openPopup();
        } else {
          marker.bindPopup("<div style='text-align: center;'>Your Location</div>").openPopup();
          /*
          marker.bindPopup(
            "<div style='text-align: center;'>Your Location" + 
            "<br/>" +
            "Default Location: " + coord_defaultLocateMe +
            "<br/>" +
            "Temp Location: " + tempCoord +
            "<br/>" +
            "Current Location: " + coordinates +
            "<br/>" +
            "</div>").openPopup();
          */
        }
      } else {
        console.error("Map instance is not available.");
      }
    });
  };

  handleUMCampus = () => {

    const { dispatch } = this.props;
    
    const { map } = this.props;    
    const umCampusCoords = coord_UmEmapCenter;

    if (map) {
      /*
      map.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          map.removeLayer(layer);
        }
      });      
      */
      mapClearLocationLayerGroup(map);
      map.flyTo(umCampusCoords, map_defaultZoomLevel);
    } else {
      console.error("Map instance is not available.");
    }
  };

  handleCloseSidebar = () => {    
    this.props.dispatch({ type: 'TOGGLE_DIRECTIONS', payload: false });
  };

  render() {
    
    const { activeTab, activeLang, activeLanguage, showDirectionsPanel } = this.props;
    
    const appPanes = [
      {
        menuItem: this.props.translate('locations'),
        render: () => (
          <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
            <LocationsControl 
              map={this.props.map} 
              activeLang={this.props.activeLang} 
              geoJsonId={this.props.geoJsonId} 
              srcCoord={this.props.srcCoord} 
              onCloseSidebar={this.handleCloseSidebar}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: this.props.translate('search'),
        render: () => (
          <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
            <DirectionsControl 
              map={this.props.map} 
              activeLang={this.props.activeLang} 
              geoJsonId={this.props.geoJsonId} 
              srcCoord={this.props.srcCoord}               
              onCloseSidebar={this.handleCloseSidebar}            
            />
            </Tab.Pane>
        ),
      },
    ];

    const ServiceTabs = () => (
      <>
        <Button
          icon
          style={{ float: 'right', marginLeft: '5px' }}
          onClick={this.handleDirectionsToggle}
        >
          <Icon name="close" />
        </Button>
        <Tab
          activeIndex={activeTab}
          onTabChange={this.handleTabChange}
          menu={{ pointing: true }}
          panes={appPanes}
        />
      </>
    );

    const viewportHeight = document.documentElement.clientHeight;
    const viewportWidth = document.documentElement.clientWidth;    

    return (
      <>
      <div id="map">
        <Button
          primary
          style={{            
            zIndex: 998,
            top: `${viewportHeight * 0.01}px`,
            left: `${viewportWidth * 0.01}px`,
            width: '120px',
            position: 'absolute',                       
          }}
          onClick={this.handleDirectionsToggle}
        >
          <Translate id={activeTab === 0 ? 'locations' : 'search'} />          
        </Button>
      </div>
        <Button
          primary
          style={{
            backgroundColor: 'white',
            zIndex: 998,
            top: `${viewportHeight * 0.01}px`,
            right: `${viewportWidth * 0.01}px`,
            width: '30px',
            height: '30px',
            position: 'absolute',
            padding: '0',
            border: '2px solid white',
            backgroundImage: `url(${myLocationButtonIcon})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
          }}
          onClick={this.handleLocateMe}
        >
        </Button>
        <Button
          primary
          style={{
            backgroundColor: 'white',
            zIndex: 998,
            top: `calc(${viewportHeight * 0.01}px + 40px)`,
            right: `${viewportWidth * 0.01}px`,
            width: '30px',
            height: '30px',
            position: 'absolute',
            padding: '0',
            border: '2px solid white',
            backgroundImage: `url(${umCampusButtonIcon})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
          }}
          onClick={this.handleUMCampus}
        >          
        </Button>
        <Button
          primary
          style={{
            backgroundColor: 'white',
            zIndex: 998,
            top: `calc(${viewportHeight * 0.01}px + 80px)`,
            right: `${viewportWidth * 0.01}px`,
            width: '30px',
            height: '30px',
            position: 'absolute',
            padding: '0',
            border: '2px solid white',
            backgroundImage: `url(${englishButtonIcon})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
          }}
          onClick={() => this.handleLanguageChange('en')}
        >          
        </Button>
        <Button
          primary
          style={{
            backgroundColor: 'white',
            zIndex: 998,
            top: `calc(${viewportHeight * 0.01}px + 120px)`,
            right: `${viewportWidth * 0.01}px`,
            width: '30px',
            height: '30px',
            position: 'absolute',
            padding: '0',
            border: '2px solid white',
            backgroundImage: `url(${chineseButtonIcon})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
          }}
          onClick={() => this.handleLanguageChange('zh')}
        >          
        </Button>
        <Button
          primary
          style={{
            backgroundColor: 'white',
            zIndex: 998,
            top: `calc(${viewportHeight * 0.01}px + 160px)`,
            right: `${viewportWidth * 0.01}px`,
            width: '30px',
            height: '30px',
            position: 'absolute',
            padding: '0',
            border: '2px solid white',
            backgroundImage: `url(${portugueseButtonIcon})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
            visibility: 'hidden', 
          }}
          onClick={() => this.handleLanguageChange('pt')}
        >          
        </Button>
        <Drawer
          enableOverlay={false}
          //open={isSidebarOpen}          
          //open={this.props.showDirectionsPanel}
          open={showDirectionsPanel}
          direction="left"
          size="400"
          style={{
            zIndex: 1000,
            overflow: 'auto',
          }}
        >
          <div>
            <Segment basic style={{ paddingBottom: 0 }}>
              <div>
                <ServiceTabs />
              </div>
            </Segment>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              margin: '1rem',
            }}
          >
          </div>
        </Drawer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { message, activeTab, activeLang, geoJsonId, srcCoord, showDirectionsPanel } = state.common;
  return {
    message,
    activeTab,
    activeLang,
    geoJsonId,
    srcCoord,
    showDirectionsPanel,
  };
};

export default connect(mapStateToProps)(withLocalize(MainControl));